// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__TteUg","list":"styles_list__3lXOk"};